import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { HubConnectionBuilder, HubConnectionState, HttpTransportType } from "@microsoft/signalr";
import { signalREventReceived, serverEventReceived } from "actions/actionCreators/signalRActions";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { showError, showInfo } from "actions/actionCreators/snackbarActions";
import { env } from "utils/env";
import { onReceiveEvent } from "utils/events/waitForEvent";

let whenSignalRReadyProm;

class NotificationProvider extends React.PureComponent {
  constructor(props) {
    super(props);

    this.accessTokenFactory = this.accessTokenFactory.bind(this);
  }

  accessTokenFactory = () => {
    return this.props.access_token;
  };

  componentDidUpdate(prevProps) {
    if (this.props.access_token !== prevProps.access_token && this.props.access_token) this.tryStartConnection();
  }

  componentDidMount() {
    this.createSignalRConnection();

    if (this.props.access_token) this.tryStartConnection();
  }

  componentWillUnmount() {
    this.connection.stop();
  }

  createSignalRConnection() {
    this.connection = new HubConnectionBuilder()
      .withUrl(env.REACT_APP_SIGNAL_R_URL + "/events", {
        accessTokenFactory: this.accessTokenFactory,
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
      })
      .withAutomaticReconnect()
      .build();

    this.connection.onclose(this.onClosed);
    this.connection.onreconnecting(this.onClosed);
    this.connection.onreconnected(this.onReconnected);
    this.connection.on("SendServerEvent", event => {
      this.onEventReceived(event);
      onReceiveEvent(event);
    });
  }

  onClosed = () => {
    whenSignalRReadyProm = Promise.reject({ message: "SignalR connection closed" });
    this.props.showError("SignalR connection closed");
  };
  onReconnected = () => {
    whenSignalRReadyProm = Promise.resolve({ message: "SignalR reconnected" });
    this.props.showInfo("SignalR reconnected");
  };

  tryStartConnection() {
    if (this.connection.state !== HubConnectionState.Disconnected) {
      //disconnected
      return whenSignalRReadyProm;
    }

    whenSignalRReadyProm = this.connection.start().catch(err => {
      throw new Error(err.message || "SignalR server unreachable");
    });
    return whenSignalRReadyProm;
  }

  onEventReceived = event => {
    this.props.dispatchEvent(event);
    if (event.eventType) {
      this.props.dispatchServerEvent(event);
    }
  };

  render() {
    return React.Children.only(this.props.children);
  }
}

NotificationProvider.propTypes = {
  access_token: PropTypes.string,
  dispatchEvent: PropTypes.func.isRequired,
  dispatchServerEvent: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  showInfo: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired
};

export function whenSignalRReady() {
  return whenSignalRReadyProm;
}

function mapStateToProps(state) {
  let access_token;
  if (state.oidc.user && state.oidc.user.access_token) {
    access_token = state.oidc.user.access_token;
  } else {
    if (sessionStorage.getItem("access_token")) {
      access_token = sessionStorage.getItem("access_token");
    }
  }

  return {
    access_token
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchEvent: event => dispatch(signalREventReceived(event)),
    dispatchServerEvent: event => dispatch(serverEventReceived(event)),
    showError: msg => dispatch(showError(msg)),
    showInfo: msg => dispatch(showInfo(msg))
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(NotificationProvider);
